module.exports = __webpack_public_path__ + "img/table1.4a7dc610.png";